<template>
  <b-form
    :id="formId"
    class="modal-form"
    @submit.prevent="insertOrUpdate"
    @reset="onReset"
  >
    <div class="card card-default">
      <div class="card-body">
        <div
          v-if="!_.isEmpty(errors)"
          class="alert alert-danger"
        >
          <strong>{{ $t('JSON.whoops') }}!</strong> {{ $t('JSON.there-were-some-problems-with-your-input') }}<br><br>
          <ul>
            <li
              v-for="(error, key) in errors"
              :key="key"
            >
              {{ error }}
            </li>
          </ul>
        </div>

        <VueFormGenerator
          :schema="form.schema"
          :model="form.model"
          :options="form.options"
        />

        <div class="col-lg-12 col-md-12">
          <div class="modal-btn text-center">
            <button
              type="submit"
              class="btn btn-default"
            >
              {{ $t('JSON.save') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import formHelpers from '@/mixins/admin/helpers/form-helpers';

export default {
  components: {
    // ChannelSearch: () => import('@/components/admin/fetcher/modals/search/ChannelSearch'),
    // ListSearch: () => import('@/components/admin/fetcher/modals/search/ListSearch'),
  },

  mixins: [formHelpers],

  props: {
    mode: {
      type: String,
      default: () => 'add',
    },
    feedRule: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      listener: null,
      errors: {},
      api: {
        add: '/api/fetcher/admin/feedRules',
        edit: `/api/fetcher/admin/feedRules/${this.feedRule.id}`,
      },
    };
  },

  computed: {
    _() {
      return _;
    },

    formId() {
      return 'feedRule-form';
    },
  },

  mounted() {
    this.generateSchema('fetcher', 'FeedRule', this.mode);
    this.initForm();
  },

  methods: {
    clearForm() {
      this.form.feedRule = '';
    },

    initForm() {
      if (this.feedRule) {
        // console.log('feedRuleForm.initForm.feedRule', this.feedRule);
        this.loadModel(this.feedRule);
      }
    },
  },
};
</script>
